export const isUSRegion = (): boolean => {
  return ["eu.uptime.com"].every((domain) => window.location.hostname.indexOf(domain) === -1);
};
